<div *ngIf="loaded">
  <div class="wrapper-content">
    <div
      cdkFocusRegionstart
      class="top"
      *ngIf="mobile"
      [ngStyle]="{ background: 'url(' + booth.settings.detailImg + ') no-repeat top center fixed', 'background-size': 'contain' }"
    >
      <button class="backButton" mat-icon-button (click)="goBack()">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
    <div class="top" *ngIf="!mobile">
      <img [src]="booth.settings.detailImg" style="width: 100%; aspect-ratio: 16/9; object-fit: cover;" />
      <div style="display: flex; flex-direction: row; gap: 16px; position: absolute; left: 16px; top: 16px; margin-right: 76px;">
        <mat-chip *ngIf="!mobile" disableRipple="true">{{ booth.settings.name }}</mat-chip>
        <mat-chip style="cursor: pointer;" *ngIf="!mobile && data.showExpoTag" disableRipple="true" (click)="routeToExpo()"
          >In: {{ booth.tradeFairName }}</mat-chip
        >
      </div>
      <button class="backButton" mat-icon-button (click)="goBack()">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
    <div *ngIf="!mobile" class="bottom">
      <div class="wrapper-areas">
        <div *ngFor="let area of booth.areas" class="areas flip-card">
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <img class="area-icon" alt="Area Icon" [src]="area.icon | safe" />
              </div>
              <div class="flip-card-back" (click)="openArea(area)">
                <span class="areaName" [innerHtml]="area.name | safeHTML"></span>
              </div>
            </div>
          </div>
        </div>
        <div class="stylingHelper"></div>
      </div>

      <div class="text-field">
        <h1 [ngStyle]="{ color: sloganColor }" [innerHtml]="booth.settings.textHeadline | safeHTML"></h1>
        <div class="subHeader" *ngIf="booth.settings.textSubHeadline" [innerHtml]="booth.settings.textSubHeadline | safeHTML"></div>
        <div class="text" id="expandText" [ngClass]="{ limitTextHeight: isReadMore }" [innerHtml]="booth.settings.text | safeHTML"></div>
        <button
          [ngStyle]="{ 'background-color': sloganColor }"
          *ngIf="
            document.getElementById('expandText').offsetHeight >= 280 ||
            (screen.width <= 699 && document.getElementById('expandText').offsetHeight >= 250)
          "
          mat-raised-button
          (click)="showText()"
        >
          {{ isReadMore ? booth.settings.learnMoreButton : booth.settings.hideButton }}
        </button>
      </div>
    </div>

    <div *ngIf="mobile" class="bottom-mobile">
      <div class="text-field">
        <h1 [ngStyle]="{ color: sloganColor }" [innerHtml]="booth.settings.textHeadline | safeHTML"></h1>
        <div class="subHeader" *ngIf="booth.settings.textSubHeadline" [innerHtml]="booth.settings.textSubHeadline | safeHTML"></div>
        <div class="text" id="expandText" [ngClass]="{ limitTextHeight: isReadMore }" [innerHtml]="booth.settings.text | safeHTML"></div>
        <div class="learnMoreArea" [ngStyle]="{ color: sloganColor }" (click)="showText()">
          <span>{{ isReadMore ? booth.settings.learnMoreButton : booth.settings.hideButton }}</span>
          <mat-icon style="font-size: 21px;">{{ isReadMore ? 'expand_more' : 'expand_less' }}</mat-icon>
        </div>
      </div>

      <div class="wrapper-areas">
        <div *ngFor="let area of booth.areas" class="areas flip-card">
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <img class="area-icon" alt="Area Icon" [src]="area.icon | safe" />
              </div>
              <div class="flip-card-back" (click)="openArea(area)">
                <span class="areaName" [innerHtml]="area.name | safeHTML"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
